import { motion } from 'framer-motion'
import { SparkCube, PlayCube, RepeatCube } from './Brand'

// Shown during the login → dashboard transition. The three brand cubes
// pulse and bob in sequence, like the system "spinning up".
const cubes = [SparkCube, PlayCube, RepeatCube]

export default function Loader() {
  return (
    <motion.div
      className="loader"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="loader-inner">
        <div className="cube-row">
          {cubes.map((Cube, i) => (
            <motion.div
              key={i}
              initial={{ y: 0, scale: 1, opacity: 0.5 }}
              animate={{ y: [0, -14, 0], scale: [1, 1.12, 1], opacity: [0.5, 1, 0.5] }}
              transition={{
                duration: 1,
                repeat: Infinity,
                delay: i * 0.18,
                ease: 'easeInOut',
              }}
            >
              <Cube width={44} height={44} />
            </motion.div>
          ))}
        </div>
        <motion.div
          className="loader-text"
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
        >
          Spinning up your command center…
        </motion.div>
      </div>
    </motion.div>
  )
}
